<proffeo-ui-page-wrapper>
  <div
    pageActions
    class="flex w-full justify-between"
  >
    <proffeo-ui-input
      (debouncedValueChange)="searchValue.set($event)"
      [debounceMs]="300"
      variant="search"
      placeholder="placeholders.search-input"
    />
    <proffeo-ui-button
      (clicked)="openAndHandleCreateUserDialog()"
      variant="accent"
      fontIcon="add"
      text="users-list-add-user"
    ></proffeo-ui-button>
  </div>
  <div class="w-full pt-3 lg:pt-6">
    <div
      [proffeoSpinner]="companyUsersPageList() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col gap-2 lg:overflow-x-auto lg:border-1 lg:border-proffeo-border lg:rounded-md lg:bg-proffeo-surface"
    >
      @if (companyUsersPageList()?.content?.length === 0) {
        <div class="flex w-full items-center justify-center p-4">
          <p>{{ 'placeholders.no-results-found' | translate }}</p>
        </div>
      } @else if (companyUsersPageList(); as pageList) {
        <proffeo-users-list
          (lockUser)="lockUser($event)"
          (unlockUser)="unlockUser($event)"
          (deleteUser)="deleteUser($event)"
          (resendActivationLink)="resendActivationLink($event)"
          [users]="pageList.content"
          class="w-full"
        ></proffeo-users-list>
        @if (pageList.content?.length > 0 && pageList.total && (searchValue()?.length === 0 || !searchValue())) {
          <proffeo-pagination
            [page]="page"
            [limit]="limit"
            [total]="pageList.total"
          ></proffeo-pagination>
        }
      }
    </div>
  </div>
  <proffeo-ui-button
    (clicked)="openAndHandleCreateUserDialog()"
    variant="accent"
    fontIcon="add"
    class="fixed bottom-5 right-5 lg:bottom-10 lg:right-10 z-10"
  ></proffeo-ui-button>
</proffeo-ui-page-wrapper>
